import React from "react";
import { Modal, Button } from "react-bootstrap";

const ConfirmationDialog = ({
  show,
  message = "Are you sure you want to proceed?",
  onCancel,
  confirmText = "Yes",
  cancelText = "No",
  state,
  handleConfirmDialogClose,
  onSuccess
}) => {
  const onConfirm = () => {
    onSuccess(state.data);
    handleConfirmDialogClose();
  };

  return (
    <Modal show={show} onHide={onCancel} centered backdrop="static">
      <Modal.Body className="text-center p-4">
        <p className="text-secondary fs-6 mb-4">{message}</p>
        
        <div className="d-flex justify-content-center gap-3 mt-4">
          <Button 
            variant="secondary" 
            onClick={handleConfirmDialogClose} 
            className="px-4 py-2"
            style={{ minWidth: "100px" }}
          >
            {cancelText}
          </Button>
          <Button
            onClick={onConfirm}
            variant="primary"
            className="px-4 py-2"
            style={{ 
              minWidth: "100px",
              backgroundColor: "#4682b4", 
              borderColor: "#228B22" 
            }}
          >
            {confirmText}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default React.memo(ConfirmationDialog);